import { Pagination } from "@mui/material";
import * as React from "react";


interface IProps {
    countPages :number;
    activePage : number;
    handlePageChange : (event: React.ChangeEvent<unknown>, value: number) => void;
}

export const SimplePagination = (props: IProps) => {

    return (
        <Pagination
            count={props.countPages}
            page={props.activePage}
            onChange={props.handlePageChange}
            variant="outlined"
            shape="rounded"
            color="primary"
            showFirstButton
            showLastButton />
    );
}